import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";

import SchedulingQuestions from './SchedulingQuestions'
import InHomeSchedulingButtons from './InHomeSchedulingButtons';
import AppointmentOverview from './AppointmentOverview';
import StickyProgressBar from '../common/StickyProgressBar';

const InHomeWhoConfirm = ({ history, selectedUsers, }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhoConfirm.Displayed`, new Date(), Tools.getURLPath());
    }, []);

    const onClickPrevious = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhoConfirm.Previous.Clicked`, new Date(), Tools.getURLPath())
        history.push("/inhomeschedule/s1");
    }

    const onClickNext = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhoConfirm.Next.Clicked`, new Date(), Tools.getURLPath())
        history.push("/inhomeschedule/s3")
    }


    return (
        <>
            {selectedUsers?.length < 1 ?
                <Redirect to='/inhomeschedule/s1' /> :
                <>
                    <StickyProgressBar className="inhome" widthInPercent={1 / 6 * 100} />
                    <div className="container-fluid body-content inhome inhome-scheduling inhome-scheduling-who-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="row flex">
                                    <div className="in-home-left-panel">
                                        <div className="detail-wrapper">
                                            <h1 className="page-heading">Is this correct?</h1>
                                            <p className="subheading-info">
                                                Please confirm the information we have for each person receiving a vaccine.
                                            </p>

                                            <div className="recipient-details-wrapper">
                                                {selectedUsers?.length && selectedUsers.map((u, i) => {
                                                    return <div key={i}> <h2>Recipient {i + 1}</h2>
                                                        <div className="recipient-details" >
                                                            <div><span className="recipient-title">First Name:</span> {u.firstName}</div>
                                                            <div><span className="recipient-title">Last Name:</span> {u.lastName}</div>
                                                            <div><span className="recipient-title">Date of Birth:</span> {u.dob}</div>
                                                        </div>
                                                    </div>
                                                })}
                                            </div>

                                            <InHomeSchedulingButtons leftOnClick={onClickPrevious} rightOnClick={onClickNext} />

                                            <p className="help-detail">
                                                If any of the information above is incorrect, please call <a className="phone-link" href="tel:833.466.3020">833.466.3020</a>.
                                            </p>

                                        </div>
                                        <SchedulingQuestions />
                                    </div>
                                    <div className="in-home-right-panel">
                                        <AppointmentOverview recipientsPhase={true} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </>
            }
        </>
    );
}

const mapStateTopProps = state => {
    return {
        selectedUsers: state.inHome.selectedUsers
    }
}

export default connect(mapStateTopProps)(InHomeWhoConfirm);